import React from "react";
import PaginationTable from "../../../../components/paginationTable/PaginationTable";
import {
  Comparator,
  dateFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import CreateHardwareDialog from "./dialogs/createHardwareDialog/CreateHardwareDialog";
import Button from "react-bootstrap/Button";
import UpdateHardwareDialog from "./dialogs/updateHardwareDialog/UpdateHardwareDialog";
import UnsavedChangesDialog from "../../../../components/dialogs/unsavedChangesDialog/UnsavedChangesDialog";
import HardwareActionCell from "./hardwareActionCell/HardwareActionCell";
import HardwareStatusCell from "./hardwareStatusCell/HardwareStatusCell";
import StorageService from "../../../../services/StorageService";
import MarkdownViewerDialog from "../../../../components/markdownViewerDialog/MarkdownViewerDialog";
import DateTimeHelper from "../../../../helpers/DateTimeHelper";

import {
  ButtonGroup,
  Col,
  Container,
  FormControl,
  InputGroup,
  Row,
  ToggleButton,
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import APIErrorHelper from "../../../../helpers/APIErrorHelper";
import DeleteDialog from "../../../../components/dialogs/deleteDialog/DeleteDialog";

import "./HardwareIndexTab.css";
import PaginationTableFilterToggle
  from "../../../../components/paginationTableFilterToggle/PaginationTableFilterToggle";

class HardwareIndexTab extends React.Component {
  tableId = "hardwareTable";

  constructor(props) {
    super(props);
    let showFilters = StorageService.tableConfigShowFilters(this.tableId);
    this.state = {
      hardware: [],
      searchPattern: "",
      showCreateModal: false,
      showDeleteSelectedModal: false,
      showDeleteModal: false,
      showUpdateModal: false,
      showRemarksModal: false,
      showUnsavedChangesDialog: false,
      selectedHardware: null,
      displayFilter: showFilters ? "initial" : "none",
      showFilters,
      dialogApiError: "",
      apiError: "",
    };

    this.loadData = this.loadData.bind(this);
    this.loadCachedData = this.loadCachedData.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleCreateHardware = this.handleCreateHardware.bind(this);
    this.handleUpdateHardware = this.handleUpdateHardware.bind(this);
    this.handleDeleteHardware = this.handleDeleteHardware.bind(this);
  }

  async componentDidMount() {
    this.paginationTableRef = React.createRef();
    this.loadCachedData();
    await this.loadData();
  }

  async handleSearch() {
    try {
      let hardware;
      if (this.state.searchPattern.length === 0) {
        hardware = await CamplaCoreService.getAllHardware();
      } else {
        const tags = this.state.searchPattern
          .toLowerCase()
          .replace(/\s\s+/g, " ")
          .split(" ");
        hardware = await CamplaCoreService.getAllHardwareByTags(tags);
      }
      hardware = hardware.sort(
        (a, b) => Date.parse(b.updated_at) - Date.parse(a.updated_at)
      );
      this.setState({ hardware: hardware });
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  async handleCreateHardware(hardware) {
    try {
      const createdHardware = await CamplaCoreService.createHardware(hardware);
      const updatedHardware = [...this.state.hardware, createdHardware];
      StorageService.set("hardware", updatedHardware);
      this.setState({
        showCreateModal: false,
        hardware: updatedHardware,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED:
              "Hardware.Tabs.Index.APIError.PreconditionFailed",
            CONFLICT: "Hardware.Tabs.Index.APIError.CreateConflict",
          },
          this.props.t
        ),
      });
    }
  }

  async handleUpdateHardware(hardware) {
    try {
      const updatedHardware = await CamplaCoreService.updateHardware(
        this.state.selectedHardware._id,
        hardware
      );
      const updatedHardwareList = this.state.hardware.map((hw) =>
        hw._id === updatedHardware._id ? updatedHardware : hw
      );
      StorageService.set("hardware", updatedHardwareList);
      this.setState({
        showUpdateModal: false,
        hardware: updatedHardwareList,
        selectedHardware: null,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED:
              "Hardware.Tabs.Index.APIError.PreconditionFailed",
            NOT_FOUND: "Hardware.Tabs.Index.APIError.NotFound",
            CONFLICT: "Hardware.Tabs.Index.APIError.UpdateConflict",
          },
          this.props.t
        ),
      });
    }
  }

  async handleDeleteHardware() {
    try {
      await CamplaCoreService.deleteHardware(this.state.selectedHardware._id);
      const updatedHardware = this.state.hardware.filter(
        (hw) => hw._id !== this.state.selectedHardware._id
      );
      StorageService.set("hardware", updatedHardware);
      this.setState({
        showDeleteModal: false,
        hardware: updatedHardware,
        selectedHardware: null,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED:
              "Hardware.Tabs.Index.APIError.PreconditionFailed",
            NOT_FOUND: "Hardware.Tabs.Index.APIError.NotFound",
            CONFLICT: "Hardware.Tabs.Index.APIError.DeleteConflict",
          },
          this.props.t
        ),
      });
    }
  }

  loadCachedData() {
    const cachedHardware = StorageService.getReferenceType("hardware");
    if (cachedHardware) this.setState({ hardware: cachedHardware });
  }

  async loadData() {
    try {
      let hardware = await CamplaCoreService.getAllHardware();
      hardware = hardware.sort(
        (a, b) => Date.parse(b.updated_at) - Date.parse(a.updated_at)
      );
      StorageService.set("hardware", hardware);
      this.setState({ hardware: hardware });
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  render() {
    const { t } = this.props;

    const columns = [
      {
        dataField: "status",
        text: "",
        isDummyField: true,
        csvExport: false,
        formatter: (cell, hardware) => {
          return <HardwareStatusCell hardware={hardware} />;
        },
      },
      {
        dataField: "product",
        text: t("Hardware.Tabs.Index.ColumnProduct"),
        sort: true,
        filter: textFilter({
          placeholder: t("Hardware.Tabs.Index.FilterProductPlaceholder"),
          style: { display: this.state.displayFilter },
        }),
        formatter: (product, hardware) => (
          <>
            {product}
            <br />
            <span className="tagList">{hardware.tags.join(", ")}</span>
          </>
        ),
      },
      {
        dataField: "tpmVersion",
        text: t("Hardware.Tabs.Index.ColumnTPMVersion"),
        sort: true,
        filter: textFilter({
          placeholder: t("Hardware.Tabs.Index.FilterTPMVersionPlaceholder"),
          style: { display: this.state.displayFilter },
        }),
      },
      {
        dataField: "testedOS",
        text: t("Hardware.Tabs.Index.ColumnTestedOS"),
        sort: true,
        filter: textFilter({
          placeholder: t("Hardware.Tabs.Index.FilterTestedOSPlaceholder"),
          style: { display: this.state.displayFilter },
        }),
      },
      {
        dataField: "updated_at",
        text: t("Hardware.Tabs.Index.ColumnUpdatedAt"),
        sort: true,
        formatter: (cell) => DateTimeHelper.formatDate(cell),
        filter: dateFilter({
          style: { display: this.state.displayFilter },
          defaultValue: { date: undefined, comparator: Comparator.EQ },
        }),
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
            <PaginationTableFilterToggle
                onFilterToggle={(e) => {
                  this.setState({
                    showFilters: e.currentTarget.checked,
                    displayFilter: e.currentTarget.checked ? "initial" : "none",
                  });
                }}
                showFilters={this.state.showFilters}
                tableId={this.tableId} />
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: (cell, hardware) => {
          return (
            <HardwareActionCell
              onEdit={() =>
                this.setState({
                  showUpdateModal: true,
                  selectedHardware: hardware,
                })
              }
              onDelete={() =>
                this.setState({
                  showDeleteModal: true,
                  selectedHardware: hardware,
                })
              }
              onShowRemarks={() => {
                this.setState({
                  showRemarksModal: true,
                  selectedHardware: hardware,
                });
              }}
              hasRemarks={
                typeof hardware.remarks[this.props.i18n.language] !==
                  "undefined" &&
                hardware.remarks[this.props.i18n.language].length > 0
              }
            />
          );
        },
      },
    ];

    return (
      <div>
        <CreateHardwareDialog
          show={this.state.showCreateModal}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                dialogApiError: null,
                showUnsavedChangesDialog: true,
                closeAction: () =>
                  this.setState({
                    showCreateModal: false,
                  }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showCreateModal: false,
              });
            }
          }}
          onSubmit={this.handleCreateHardware}
          dialogApiError={this.state.dialogApiError}
        />
        <MarkdownViewerDialog
          show={this.state.showRemarksModal}
          onHide={() => this.setState({ showRemarksModal: false })}
          title={this.state.selectedHardware?.product}
          text={this.state.selectedHardware?.remarks}
          lang={this.props.i18n.language}
        />
        <DeleteDialog
          show={this.state.showDeleteModal}
          onHide={() => this.setState({ showDeleteModal: false })}
          onSubmit={this.handleDeleteHardware}
          dialogApiError={this.state.dialogApiError}
          title={t("Hardware.Tabs.Index.Modal.DeleteModal.Title")}
          body={t("Hardware.Tabs.Index.Modal.DeleteModal.Text", {
            hardwareProduct: this.state.selectedHardware?.product,
          })}
          rightButtonText={t("Hardware.Tabs.Index.Modal.DeleteModal.Confirm")}
          leftButtonText={t("DialogCancel")}
        />
        <UpdateHardwareDialog
          show={this.state.showUpdateModal}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                dialogApiError: null,
                showUnsavedChangesDialog: true,
                closeAction: () => this.setState({ showUpdateModal: false }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showUpdateModal: false,
              });
            }
          }}
          onSubmit={this.handleUpdateHardware}
          hardware={this.state.selectedHardware}
          dialogApiError={this.state.dialogApiError}
        />
        <UnsavedChangesDialog
          show={this.state.showUnsavedChangesDialog}
          onHide={() => this.setState({ showUnsavedChangesDialog: false })}
          onSubmit={() => {
            this.setState({ showUnsavedChangesDialog: false });
            this.state.closeAction();
          }}
        />

        <Container className="mt-3 pl-0 pr-0">
          <Row className="pageTitle">
            <Col>
              <h2>{t("Hardware.Tabs.Index.Title")}</h2>
            </Col>
            <Col>
              <Button
                className="btn-green floatRight"
                onClick={() => this.setState({ showCreateModal: true })}
              >
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </Col>
          </Row>
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col>
              <InputGroup className="mb-3">
                <FormControl
                  placeholder={t(
                    "Hardware.Tabs.Index.Modal.Form.ProductPlaceholder"
                  )}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") this.handleSearch();
                  }}
                  onChange={(event) =>
                    this.setState({ searchPattern: event.target.value })
                  }
                  aria-describedby="hardware-search-button"
                />
                <Button
                  className="btn-green inline-button"
                  onClick={this.handleSearch}
                  id="hardware-search-button"
                >
                  <FontAwesomeIcon icon={faSearch} />
                </Button>
              </InputGroup>
            </Col>
          </Row>
          <Row className="pb-3">
            <Col>
              <PaginationTable
                data={this.state.hardware}
                sizePerPage={10}
                paginationSize={3}
                columns={columns}
                keyField={"_id"}
                ref={this.paginationTableRef}
                id={this.tableId}
                view="hardwareIndexTab"
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(HardwareIndexTab);
